import React, { Component } from "react";
import * as _ from "lodash";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import { compose } from "redux";
import { withApiService } from "../../hoc";
import { connect } from "react-redux";
import Avatar from "./../../img/no_avatar.png";
import { Fab, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import {
  getPhoto,
  savePhoto,
  trainerDelete,
  trainerLoaded,
  trainerRequest,
  trainerUpdate,
  unmountAvatar,
} from "../../../store/actions/selects";
import "./edit-trainer.scss";
import Spinner from "../../spinner";
import DialogTitle from "../../modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { Edit as EditIcon } from "@material-ui/icons";
import AddIcon from "@material-ui/core/SvgIcon/SvgIcon";
import GroupChildren from "../../groups/group/groupChildren";
import SaveChanges from "../../modal-components/modal-save-changes";
import Compress from "compress.js";
import { formatPhoneNumber, isPhoneValid } from "../../../helpers";
import { withSnackbar } from "notistack";

const useStyles = () => ({
  multilineColor: {
    color: "#7E7E7E",
    fontSize: "0.8rem",
    backgroundColor: "white",
  },
});

const compress = new Compress();

const resizeImageFn = async (file) => {
  const resizedImage = await compress.compress([file], {
    size: 2,
    quality: 1,
    maxWidth: 1920,
    maxHeight: 1080,
    resize: true,
    name: file.name,
  });
  const img = resizedImage[0];
  const base64str = img.data;
  const imgExt = img.ext;
  return Compress.convertBase64ToFile(base64str, imgExt);
};

export const customStyles = {
  singleValue: (styles) => ({
    ...styles,
    color: "#7E7E7E",
    fontSize: "0.8rem",
  }),
  control: (styles) => ({ ...styles, padding: 0, backgroundColor: "inherit" }),
  multiValueLabel: (provided) => ({
    ...provided,
    backgroundColor: "white",
    fontSize: "0.7rem",
    color: "#7E7E7E",
    padding: 0,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: "white",
  }),
};

class EditTrainer extends Component {
  state = {
    save: false,
    openDialog: false,
    imagePreviewUrl: "",
    trainer: {
      id: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      email: "",
      phone: "",
      aux: [],
    },
  };

  componentDidMount() {
    const { id } = this.props;
    this.props.trainerLoaded(id);
    this.props.getPhoto("Trainer.photo", id);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.trainer !== null &&
      this.props.trainer.id !== this.state.trainer.id
    ) {
      const trainer = this.props.trainer;
      document.title = `${trainer.full_name}`;
      const { photos } = this.props;
      if (this.props.trainer.groups?.length) {
        const children = _.flatten(
          trainer.groups?.map((item) => item.children)
        );
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        const children_count = trainer.groups
          ?.map((item) => item.children_count)
          .reduce(reducer);
        this.setState({
          ...this.state,
          children: { children_name: children },
          children_count,
        });
      }
      this.setState({
        ...this.state,
        trainer: {
          ...trainer,
          middle_name: trainer.middle_name !== null ? trainer.middle_name : "",
          birthday: trainer.birthday !== null ? trainer.birthday : "",
          phone: trainer.phone !== null ? trainer.phone : "",
        },
        avatar: photos,
      });
    }
  }

  handleChange = (field) => {
    this.setState({
      trainer: { ...this.state.trainer, ...field },
    });
  };

  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    const file = e.target.files[0];
    const size = file?.size / 1048576;
    const collection = "Trainer.photo";
    const id = this.state.trainer.id;
    if (size > 1.95) {
      resizeImageFn(file).then((image) => {
        reader.onloadend = () => {
          this.setState({
            imagePreviewUrl: reader.result,
          });
        };
        reader.readAsDataURL(image);
        if (image) {
          this.props.savePhoto(image, collection, id);
        }
      });
      this.loadedAvatar();
    } else {
      reader.readAsDataURL(file);
      this.props.savePhoto(file, collection, id);
      reader.onloadend = () => {
        this.setState({
          imagePreviewUrl: reader.result,
        });
      };
      this.loadedAvatar();
    }
  }

  loadedAvatar = () => {
    const { id } = this.props;
    setTimeout(() => {
      this.props.getPhoto("Trainer.photo", id);
      this.setState({ openDialog: false });
    }, 1000);
  };
  saveChanges = () => {
    const phoneValid = isPhoneValid(this.state.trainer.phone);
    const noticeF = this.props.enqueueSnackbar;
    if (!phoneValid) {
      noticeF("Телефон должен быть заполнен полностью", {
        variant: "error",
      });
      return;
    }

    this.props.trainerUpdate(this.state.trainer).then(() => {
      noticeF("Сохранено", {
        variant: "success",
      });
    });
  };

  render() {
    const { id, photos } = this.props;
    const { classes } = this.props;
    const { children_count, trainer, children } = this.state;

    let { imagePreviewUrl } = this.state;
    let imagePreview = null;
    if (imagePreviewUrl) {
      imagePreview = <img src={imagePreviewUrl} alt={"avatar"} />;
    } else {
      imagePreview = (
        <img src={Avatar} className="editTrainerImg" alt={"avatar"} />
      );
    }
    const photoUrl = (
      <img src={photos} className="editTrainerImg" alt={"avatar"} />
    );

    const AddPhoto = () => {
      return (
        <div className="trainerPhoto">
          <div className="noPhoto">{photos ? photoUrl : imagePreview}</div>
          <div className="profilePhoto">
            <div className="profilePhotoItem">
              <label htmlFor="upload-photo">
                <TextField
                  style={{ display: "none" }}
                  name="photo"
                  id="upload-photo"
                  onChange={(e) => {
                    this.handleImageChange(e);
                  }}
                  type="file"
                />
                <Fab
                  color="secondary"
                  size="small"
                  component="span"
                  aria-label="add"
                  variant="extended"
                >
                  {photos ? (
                    <>
                      <EditIcon /> Изменить фото
                    </>
                  ) : (
                    <>
                      <AddIcon /> Добавить фото
                    </>
                  )}
                </Fab>
              </label>
            </div>
          </div>
        </div>
      );
    };
    if (this.state.trainer.id) {
      return (
        <Box className="editTrainerContent">
          <Box className="editTrainerHeader">
            <Box className="editTrainerAvatar">
              {photos !== 0 ? (
                <div
                  className="editTrainerImg"
                  onClick={() => this.setState({ openDialog: true })}
                  style={{
                    backgroundImage: `url(${photos})`,
                  }}
                />
              ) : (
                <div
                  className="editTrainerImg"
                  onClick={() => this.setState({ openDialog: true })}
                  style={{
                    backgroundImage: `url(${Avatar})`,
                  }}
                />
              )}
            </Box>
            <Box className="trainerHeaderLabel">
              <h1>{`${trainer.last_name} ${trainer.first_name} ${trainer.middle_name}`}</h1>
              <span>Тренер</span>
            </Box>
          </Box>
          <Box className="editTrainerBlock">
            <Box className="editTrainerBlockOne">
              <Box className="blockOne">
                <label>Фамилия:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  id="lastNameTrainer"
                  name="last_name"
                  margin="dense"
                  variant="outlined"
                  multiline
                  rows={3}
                  placeholder="Фамилия"
                  value={trainer.last_name}
                  onChange={(e) =>
                    this.handleChange({ last_name: e.target.value })
                  }
                  type="text"
                />
              </Box>
              <Box className="blockOne">
                <label>Имя:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  id="firstNameTrainer"
                  name="first_name"
                  margin="dense"
                  variant="outlined"
                  multiline
                  rows={3}
                  placeholder="Имя"
                  value={trainer.first_name}
                  onChange={(e) =>
                    this.handleChange({ first_name: e.target.value })
                  }
                  type="text"
                />
              </Box>
              <Box className="blockOne">
                <label>Отчество:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  id="middleNameTrainer"
                  name="middle_name"
                  margin="dense"
                  variant="outlined"
                  multiline
                  rows={3}
                  placeholder="Отчество"
                  value={trainer.middle_name}
                  onChange={(e) =>
                    this.handleChange({ middle_name: e.target.value })
                  }
                  type="text"
                />
              </Box>
              <Box className="blockOneEducation">
                <label>Образование:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  id="educationInput"
                  name="education"
                  margin="dense"
                  variant="outlined"
                  multiline
                  rows={4}
                  placeholder="Образование"
                  value={trainer.aux[0]?.education || ""}
                  onChange={(e) =>
                    this.handleChange({ aux: [{ education: e.target.value }] })
                  }
                  type="text"
                />
              </Box>
            </Box>
            <Box className="editTrainerBlockSecond">
              <Box className="blockSecond">
                <label>Дата рождения:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  name="birthday"
                  margin="dense"
                  variant="outlined"
                  value={
                    this.state.trainer.birthday === null
                      ? ""
                      : this.state.trainer.birthday
                  }
                  onChange={(e) => {
                    this.handleChange({ birthday: e.target.value });
                  }}
                  type="date"
                />
              </Box>
              <Box className="blockSecond">
                <label>Телефон:</label>
                  <TextField
                      InputProps={{
                          className: classes.multilineColor,
                      }}
                      name="phone"
                      margin="dense"
                      variant="outlined"
                      value={
                          this.state.trainer?.phone
                              ? formatPhoneNumber(this.state.trainer.phone)
                              : ""
                      }
                      onChange={(e) => {
                          this.handleChange({ phone: e.target.value });
                      }}
                      type="text"
                  />
              </Box>
              <Box className="blockSecond">
                <label>Email:</label>
                <TextField
                  InputProps={{
                    className: classes.multilineColor,
                  }}
                  name="email"
                  margin="dense"
                  variant="outlined"
                  value={this.state.trainer.email || "email"}
                  onChange={(e) => {
                    this.handleChange({ email: e.target.value });
                  }}
                  type="email"
                />
              </Box>
            </Box>
            <Box className="editTrainerBlockThree">
              <Box>
                <GroupChildren data={children} />
              </Box>
            </Box>
            {trainer.filials && trainer.filials.length ? (
              <Box className="editTrainerBlockFour">
                <Box className="blockSecondOfTrainer">
                  <h2>Филиалы:</h2>
                  <Box className="blockSecondOf">
                    {trainer.filials?.map((item) => (
                      <ul key={item.id}>
                        <li>{item.name}</li>
                      </ul>
                    ))}
                  </Box>
                </Box>
                <Box className="blockSecondOfTrainer">
                  <h2>Группы:</h2>
                  <Box className="blockSecondOf">
                    {trainer.groups?.map((item) => (
                      <ul key={item.id}>
                        <li>{item.name}</li>
                      </ul>
                    ))}
                  </Box>
                </Box>
              </Box>
            ) : null}
          </Box>
          <Box className="analyticsTrainer">
            <h2>Аналитика сегодня:</h2>
            <Box className="analyticsBox">
              <Box className="boxTrainer">
                <h6>Ученики</h6>
                <span>{children_count || 0}</span>
              </Box>
              <Box className="boxTrainer">
                <h6>Пробные</h6>
                <span>0</span>
              </Box>
              <Box className="boxTrainer">
                <h6>Оплаты</h6>
                <span>0</span>
              </Box>
            </Box>
          </Box>
          <Box className="editTrainerButtons">
            <Box>
              <Link to="/admin/trainers">
                {" "}
                <Button
                  id="btnTrainerBack"
                  onClick={() => {
                    this.props.trainerRequest(null);
                  }}
                >
                  В раздел Тренеры{" "}
                </Button>
              </Link>

              <Button id="btnTrainerSave" onClick={this.saveChanges}>
                Сохранить
              </Button>
            </Box>

            <Link to="/admin/trainers">
              {" "}
              <Button
                id="btnTrainerDel"
                onClick={() => {
                  this.props.trainerDelete(id);
                }}
              >
                Удалить тренера
              </Button>{" "}
            </Link>
          </Box>
          <Dialog
            open={this.state.openDialog}
            onClose={() => this.setState({ openDialog: false })}
            aria-labelledby="form-dialog"
            fullWidth
            maxWidth={"xs"}
          >
            <DialogTitle
              id="form-dialog"
              onClose={() => this.setState({ openDialog: false })}
            />
            <DialogContent className="createTrainerContent">
              <AddPhoto />
            </DialogContent>
          </Dialog>
          <SaveChanges save={this.state.save} />
        </Box>
      );
    } else return <Spinner open={true} isWhite />;
  }
}
const mapStateToProps = ({ selects: { trainer, photos } }) => {
  return {
    trainer,
    photos,
  };
};

export default compose(
  withApiService(),
  connect(mapStateToProps, {
    trainerLoaded,
    trainerDelete,
    getPhoto,
    savePhoto,
    trainerUpdate,
    unmountAvatar,
    trainerRequest,
  }),
  withStyles(useStyles)
)(withSnackbar(EditTrainer));
